import { Users } from "../../../users/users";

const checkIsAdmin = (email) => {
  switch (email) {
    case "luizfernandocad@gmail.com":
    case "marcosh4@gmail.com":
    case "bpinheiro17@gmail.com":
      return true;
    default:
      return false;
  }
};

const getUserId = (loggedUser) => {
  const [user] = Users.filter((opt) => opt.uid === loggedUser.uid);
  return user.id;
};

const authReducer = (state = {}, action) => {
  switch (action.type) {
    case "USER_LOGIN_SUCCESS":
      return {
        ...state,
        ...action.user,
        isLogged: true,
        id: getUserId(action.user),
        isAdmin: checkIsAdmin(action.user.email),
      };
    case "SONG_USER":
      return {
        ...state,
        band: "Soundgarden!",
      };
    case "LOGOUT_USER":
      return (state = null);
    default:
      return state;
  }
};

export { authReducer };
